// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

/* Components */
import VueApp from './App'
import HeaderComponent from './components/common/Header'
import Dropdown from './components/common/Dropdown'

/* Directives */
import Focus from 'modules/directives/Focus'

/* Router */
import { router } from 'modules/Router'

/*
 * Import Vuex
 * */
import { store } from './store/index'

/*
 Modules
 */
import VueResource from 'vue-resource'
import VueMoment from 'vue-moment'
import VueCookie from 'vue-cookie'
import Lodash from 'lodash'
import VueFire from 'vuefire'
import VeeValidate from 'vee-validate'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import VueGtag from "vue-gtag"
import PortalVue from 'portal-vue'

/* Filters */
import VueFormatTitleize from 'modules/filters/FormatTitleize'
import VueFormatNumber from 'modules/filters/FormatNumber'
import VueFormatDecimals from 'modules/filters/FormatDecimals'
import VueFirstCharacter from 'modules/filters/FirstCharacter'
import VueFileName from 'modules/filters/FileName'
import VueUndefinedToString from 'modules/filters/UndefinedToString'
import VueFileNameWithExtension from 'modules/filters/FileNameWithExtension'

/* Styles */
import 'vue-toast/dist/vue-toast.min.css'
import 'assets/styles/style.scss'

Vue.config.productionTip = false

/*
 * By extending the Vue prototype with a new '$bus' property
 * we can easily access our global event bus from any child component.
 */
Object.defineProperty(Vue.prototype, '$bus', {
  get () {
    return this.$root.bus
  }
})

/* Components */
Vue.component('app', VueApp)
Vue.component('header-component', HeaderComponent)
Vue.component('dropdown', Dropdown)

/* Directives */
Vue.directive(Focus)

/* Modules */
Vue.use(VueResource)
Vue.use(VueMoment)
Vue.use(VueCookie)
Vue.use(Lodash)
Vue.use(VueFire)
Vue.use(VeeValidate)
Vue.use(VueGtag, {config: { id: "G-44G522HDRL" }})
Vue.use(PortalVue)
Raven
  .config('https://f7fffbb8aaa1402e87aa2218b00c930e@sentry.io/247426', {
    ignoreUrls: [
      /127\.0\.0\.1:3000/i,
      /localhost:3000/i
    ]
  })
  .addPlugin(RavenVue, Vue)
  .install()

/* Filters */
Vue.use(VueFormatTitleize)
Vue.use(VueFormatNumber)
Vue.use(VueFormatDecimals)
Vue.use(VueFirstCharacter)
Vue.use(VueUndefinedToString)
Vue.use(VueFileName)
Vue.use(VueFileNameWithExtension)

Vue.config.keyCodes = {
  // Numbers and Numpad Numbers
  numbers: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105]
}

const App = new Vue({
  store, router, ...VueApp
})

App.$mount('#app')

export { App };



// WEBPACK FOOTER //
// ./src/main.js